<template>
  <div class="home">
    <div class="container-fluid">
      <form @submit.prevent="search">
        <div class="row">
          <div class="col-md-3">
            <object-select-input
              v-model="table"
              :options="{
                objects: tables,
                objectName: 'label',
                ignoreSort: true,
                fullWidth: true
              }"/>
          </div>
          <div class="col-md-9">
            <text-input
              v-model="searchTerms"
              :options="{
                fullWidth: true,
                placeholder: 'Search For...'
              }"/>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col text-right">
            <button class="btn btn-primary btn-lg">
              <i class="fa fa-search"></i> Search
            </button>
          </div>
        </div>
      </form>
      <div v-if="data.length === 0" class="row">
        <div class="col-12">
          <div class="alert alert-info">
            No results.
          </div>
        </div>
      </div>
      <template v-for="(item, index) in data">
        <div :key="index" class="row">
          <div class="col-12">
            <!-- Contractor -->
            <div v-if="item.type === 'contractor'" class="card">
              <div class="content">
                <div class="row">
                  <div class="col-12">
                    <h5>{{ item.company }}</h5>
                    <hr>
                    <p>
                      <i class="fa fa-wrench"></i> {{ item.trades.join(', ') }}
                    </p>
                    <p v-if="item.contactPersonName">
                      <i class="fa fa-user"></i> {{ item.contactPersonName }}
                    </p>
                    <p v-if="item.email">
                      <i class="fa fa-paper-plane"></i> <a :href="'mailto:' + item.email">{{ item.email }}</a>
                    </p>
                    <p v-if="item.phoneNumber">
                      <i class="fa fa-phone"></i> <a :href="'tel:' + item.phoneNumber">{{ item.phoneNumber }}</a>
                    </p>
                    <p v-if="item.mobileNumber">
                      <i class="fa fa-mobile-alt"></i> <a :href="'tel:' + item.mobileNumber">{{ item.mobileNumber }}</a>
                    </p>
                    <p v-if="item.address">
                      <i class="fa fa-location-arrow"></i> {{ item.address }}
                    </p>
                  </div>
                </div>
                <div class="footer small">
                  <hr>
                  Contractor
                  <download-input
                    class="float-right"
                    :options="{ label: 'Download vCard', permalink: 'downloadVCard', button: true }"
                    :value="{ uuid: item.contactUuid }" />
                </div>
              </div>
            </div>
            <!-- Property -->
            <div v-else-if="item.type === 'property'" class="card">
              <div class="content">
                <div class="row">
                  <div class="col-12">
                    <router-link :to="'database-manager/properties/' + item.propertyUuid">
                      <h5>
                        {{ item.propertyAddress }}
                      </h5>
                    </router-link>
                    <hr>
                    <p v-if="item.name">
                      <strong>Company:</strong> <router-link :to="'database-manager/companies/' + item.CompanyUuid">
                        {{ item.name }}
                      </router-link>
                    </p>
                    <p v-if="item.planOfSubdivisionNumber">
                      <strong>Strata Number:</strong> {{ item.planOfSubdivisionNumber }}
                    </p>
                    <p v-else-if="item.strataPlanNumber">
                      <strong>Strata Number:</strong> {{ item.strataPlanNumber }}
                    </p>
                    <p v-if="item.insuranceCompany">
                      <strong>Insurance Company:</strong> {{ item.insuranceCompany }}
                    </p>
                    <p v-if="item.lots">
                      <strong>Lots:</strong> {{ item.lots }}
                    </p>
                    <p v-if="item.accessInstructions">
                      <strong>Access Instructions:</strong> {{ item.accessInstructions }}
                    </p>
                  </div>
                </div>
                <div class="footer small">
                  <hr>
                  Property
                </div>
              </div>
            </div>
            <!-- Manager -->
            <div v-else-if="item.type === 'manager'" class="card">
              <div class="content">
                <div class="row">
                  <div class="col-12">
                    <h5>
                      <router-link :to="'database-manager/oc-managers/' + item.contactUuid">
                        {{ item.fullName }}
                      </router-link >
                      (<router-link :to="'database-manager/companies/' + item.CompanyUuid">
                        {{ item.name }}
                      </router-link>)
                    </h5>
                    <hr>
                    <p v-if="item.username">
                      <i class="fa fa-paper-plane"></i> <a :href="'mailto:' + item.username">{{ item.username }}</a>
                    </p>
                    <p v-else-if="item.email">
                      <i class="fa fa-paper-plane"></i> <a :href="'mailto:' + item.email">{{ item.email }}</a>
                    </p>
                    <p v-if="item.businessPhone">
                      <i class="fa fa-phone"></i> <a :href="'tel:' + item.businessPhone">{{ item.businessPhone }}</a>
                    </p>
                    <p v-if="item.phone">
                      <i class="fa fa-mobile-alt"></i> <a :href="'tel:' + item.phone">{{ item.phone }}</a>
                    </p>
                    <p v-if="item.address">
                      <i class="fa fa-location-arrow"></i> {{ item.address }}
                    </p>
                    <p v-else-if="item.officeAddress">
                      <i class="fa fa-location-arrow"></i> {{ item.officeAddress }}
                    </p>

                  </div>
                </div>
                <div class="footer small">
                  <hr>
                  Manager
                  <download-input
                    class="float-right"
                    :options="{ label: 'Download vCard', permalink: 'downloadVCard', button: true }"
                    :value="{ uuid: item.contactUuid }" />
                </div>
              </div>
            </div>
            <!-- Company -->
            <div v-else class="card">
              <div class="content">
                <div class="row">
                  <div class="col-12">
                    <router-link :to="'database-manager/companies/' + item.uuid">
                      <h5>
                        {{ item.name }}
                      </h5>
                    </router-link>
                    <hr>
                    <p class="alert alert-primary" v-if="item.masterNote" v-html="item.masterNote"></p>
                    <p v-if="item.email">
                      <i class="fa fa-paper-plane"></i> <a :href="'mailto:' + item.email">{{ item.email }}</a>
                    </p>
                    <p v-if="item.phone">
                      <i class="fa fa-phone"></i> <a :href="'tel:' + item.phone">{{ item.phone }}</a>
                    </p>
                    <p v-if="item.address">
                      <i class="fa fa-envelope"></i> {{ item.address }}
                    </p>
                    <p v-if="item.officeAddress">
                      <i class="fa fa-building"></i> {{ item.officeAddress }}
                    </p>
                  </div>
                </div>
                <div class="footer small">
                  <hr>
                  Company
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
  h5 {
    font-weight: bold;
  }
</style>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import Api from '@/vuex/api'
  import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
  import TextInput from '@/components/inputs/TextInput'
  export default {
    name: 'DatabaseSearch',
    components: {
      DownloadInput,
      ObjectSelectInput,
      TextInput
    },
    data () {
      return {
        data: [],
        instance: false,
        table: '0',
        searchTerms: '',
        tables: [
          {
            uuid: '0',
            label: 'Entire Database'
          },
          {
            uuid: '1',
            label: 'Managers'
          },
          {
            uuid: '2',
            label: 'Contractors'
          },
          {
            uuid: '3',
            label: 'Companies'
          },
          {
            uuid: '4',
            label: 'Properties'
          }
        ]
      }
    },
    mounted () {
      this.instance = new Api()
    },
    methods: {
      async search () {
        let results = await this.instance.databaseSearch({
          searchTerms: this.searchTerms, table: this.table
        })
        for (let result of results) {
          if (result.hasOwnProperty('company')) {
            result.type = 'contractor'
          } else if (result.hasOwnProperty('manager')) {
            result.type = 'manager'
          } else if (result.hasOwnProperty('buildingName')) {
            result.type = 'property'
          } else {
            result.type = 'company'
          }
          if (result.nameranking < 0.15) {
            result.nameranking = 0
          }
          if (!result.tradesranking || result.tradesranking < 0.15) {
            result.tradesranking = 0
          }
          if (!result.companyranking || result.companyranking < 0.15) {
            result.companyranking = 0
          }
          result.totalRank = result.nameranking + result.tradesranking + result.companyranking
        }
        this.data = results.sort(function (a, b) {
          return b.totalRank - a.totalRank
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/DatabaseSearch.vue